import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, Button, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import HotelList from './HotelList';
import Loading from '../../../components/Loading';

class HotelAddDetail extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.state = {
      search: this.props.search,
      save: false,
    };
  }
  handleChange(e) {
    this.setState({
      search: e.target.value,
      save: true,
    });
  }
  handleSearch() {
    if (this.state.search) {
      if (this.state.search.length > 2) {
        console.log('Go search: ', this.state.search);
        this.props.findHotels(this.props.event, this.state.search);
      }
    }
  }
  render() {
    const hotelsExist = this.props.hotels.length > 0;
    return (
      <div>
        <FormGroup controlId="hotel-find">
          <ControlLabel>Search</ControlLabel>
          <FormControl
            type="text"
            name="search"
            onChange={this.handleChange}
            value={this.state.search}
            placeholder="Search for hotel by name"
          />
          <HelpBlock>Search for hotel to add to your bid process.</HelpBlock>
          <Button onClick={this.handleSearch}>Search</Button>
        </FormGroup>
        {this.props.fetching && <Loading />}
        {hotelsExist && (
          <HotelList
            eventId={this.props.event}
            hotels={this.props.hotels}
            selectHotel={this.props.selectHotel}
            favoriteHotel={this.props.favoriteHotel}
            displayHotel={this.props.displayHotel}
          />
        )}
      </div>
    );
  }
}

HotelAddDetail.propTypes = {
  hotels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      features: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  favoriteHotel: PropTypes.func.isRequired,
  selectHotel: PropTypes.func.isRequired,
  findHotels: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,
};

HotelAddDetail.defaultProps = {
  hotels: [],
};
export default HotelAddDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelAddDetail.js